import AppContext from "AppContext";
import { useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { Button, FormGroup, Input, Modal, ModalBody, ModalHeader, Table } from "reactstrap";
import componenteService from "services/ComponenteService";
import { StatusComponenteEnum } from "services/ComponenteService";
import descarteService from "services/DescarteService";

export default function ModalIncluir({ config, onClose, onSelect }) {
  const [termo, setTermo] = useState('')
  const [items, setItems] = useState([])
  const [inclusos, setInclusos] = useState(config?.inclusos || [])
  const termoRef = useRef()
  const { state } = useContext(AppContext)

  const handleOpened = () => {
    termoRef.current?.focus()
  }

  useEffect(() => {
    setTermo('')
    setItems([])
    setInclusos(config?.inclusos || [])
  }, [config])

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!termo) {
      toast.error("Preencha o QR Code")
      return
    }

    componenteService.get(state.contrato.id, null, null, termo, null, null, false).then(res => {
      if (res.success) {
        if (res.data.length == 1) {
          const item = res.data[0]
          if (item.status == StatusComponenteEnum.ESTOQUE && !inclusos.includes(item.id)) {
            handleIncluir(res.data[0])
          }
        }
        setItems(res.data)
      }
    })
  }

  const handleIncluir = (item) => {
    onSelect && onSelect(item)
    setInclusos([...inclusos, item.id])
  }

  return (
    <Modal isOpen={!!config} toggle={onClose} size="lg" onOpened={handleOpened}>
      <ModalHeader toggle={onClose}>Buscar Componente</ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit} className="row">
          <FormGroup className={`col-12`}>
            <label htmlFor="termo">QR Code</label>
            <Input id="termo" innerRef={termoRef} type="text" value={termo} onChange={e => setTermo(e.target.value)} />
          </FormGroup>
          <div className="col-12 text-right">
            <Button type="submit" color="primary">Buscar</Button>
            <Button type="button" color="primary" outline onClick={onClose}>Fechar</Button>
          </div>
        </form>
        <Table className="align-items-center table-flush mt-4" responsive>
          <thead className="thead-light">
            <tr>
              <th scope="col">QRCode</th>
              <th scope="col">Tipo</th>
              <th scope="col">Modelo</th>
              <th scope="col">Estado</th>
              <th scope="col">Status</th>
              <th scope="col" style={{ width: 60 }}></th>
            </tr>
          </thead>
          <tbody>
            {items.map(item => (
              <tr key={item.id}>
                <td>{item.qrCode}</td>
                <td>{item.tipoComponente}</td>
                <td>{item.modelo}</td>
                <td>{item.estadoFmt}</td>
                <td>{item.statusFmt}</td>
                <td>
                  <Button
                    color="primary"
                    size="sm"
                    onClick={() => handleIncluir(item)}
                    disabled={item.status != StatusComponenteEnum.ESTOQUE || inclusos.includes(item.id)}
                  >
                    Incluir
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </ModalBody>
    </Modal>
  )
}